module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-supply-chain-industry-future.93dd76f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-supply-chain-industry-future.jpg
// module id = BCBJ
// module chunks = 0